import Splide from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';

export class InterviewSlider {
  constructor() {
    this.DOM = {
      sliders: document.querySelectorAll('.js-interviewSlider'),
      sliderNav: document.querySelector('.js-interviewSliderNav'),
      sliderNavItem: document.querySelectorAll('.js-interviewSliderNavItem'),
    };

    this.init();
  }

  init() {

    // if( !this.DOM.sliders ) return;
    // document.querySelector(`.js-mv__title[data-index="1"]`).classList.add('is-active');
    
    this.DOM.sliders.forEach(slider => this.initSlider(slider));
  }

  initSlider(slider) {

    const splide = new Splide(slider, this.getSplideOptions());


    // スライダーが切り替わったときナビのアクティブ表示変更
    splide.on( 'move', () => {
      this.DOM.sliderNavItem.forEach(nav => { 
        nav.classList.remove('is-active');
      });
      this.DOM.sliderNavItem[splide.index].classList.add('is-active');
    });

    // ナビをクリックしたときにスライドを変更
    // this.DOM.sliderNavItem.forEach(nav => { 
    //   nav.addEventListener('click',function(e) {
    //     let index = this.dataset.sliderindex;
    //     splide.go(index);
    //   });
    // });
    const thumbnails = document.querySelectorAll('.js-interviewSliderNavItem');

    const initThumbnail = (thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        splide.go(index);
      });
    }
    for (let i = 0; i < this.DOM.sliderNavItem.length; i++) {
      initThumbnail(thumbnails[i], i);
    }
    splide.mount({ Intersection });
  }

  getSplideOptions() {
    return {
      // type: 'loop',
      autoplay: false,
      interval: 5000,
      speed: 1200,
      perMove: 1,
      perPage: 2,
      gap: '3.2rem',
      trimSpace: false,
      isNavigation: true,
      pagination: false,
      resetProgress: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      drag: false,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      
      intersection: {
        inView: { autoplay: true },
        outView: { autoplay: false },
      },
      breakpoints: {
        750: {
          drag: true,
          perPage: 1,
        },
      },
    };
  }

}

